import { useInView } from 'react-cool-inview';

import { TrackerPlacementName } from '@/app/_tracker/TrackerPlacementName';
import {
    EventType,
    ListingEvents,
    Trackers,
} from '@/app/_tracker/eventMapping';
import { useEventTracker } from '@/app/_tracker/useEventTracker';
import { Property } from '@/modules/core/gql/generated';

const useRecommendationSectionSegment = ({
    property,
    index,
    threshold = 0.8,
}: {
    property: Property;
    index: number;
    threshold?: number;
}) => {
    const { trackEvent } = useEventTracker();

    const percentage = property.priceDrop?.percentage?.value;
    const label = property.priceDrop?.shortText;
    const isNpl = property.specialFlag?.isNpl;

    const { observe } = useInView({
        threshold,
        unobserveOnEnter: true,
        onEnter: () => {
            trackEvent(
                {
                    eventName: ListingEvents.ListingImpression,
                    eventType: EventType.Impression,
                    placementName:
                        TrackerPlacementName.LDPSpecialOfferRecommendation,
                    featureType: '',
                    pageType: 'LDP',
                    propertiesGA4: {
                        position: index,
                    },
                    properties: {
                        listing_position_in_placement: index,
                        feature_percentage_drop: percentage
                            ? +percentage
                            : undefined,
                        feature_discount_statement: label || undefined,
                        ...(isNpl && {
                            feature_section_name: 'Aset Bank Lainnya',
                        }),
                        listing: property,
                        project_id:
                            property?.propertyPartner?.primaryProject?.originId,
                        developer_id:
                            property?.propertyPartner?.agent?.originId ||
                            property?.unregisterProject?.developerId,
                    },
                },
                [Trackers.Segment],
            );
        },
    });

    const onClickCard = () => {
        setTimeout(() => {
            trackEvent(
                {
                    eventName: ListingEvents.ListingClick,
                    eventType: EventType.Click,
                    placementName:
                        TrackerPlacementName.LDPSpecialOfferRecommendation,
                    featureType: '',
                    pageType: 'LDP',
                    propertiesGA4: {
                        position: index,
                    },
                    properties: {
                        listing_position_in_placement: index,
                        feature_percentage_drop: percentage
                            ? +percentage
                            : undefined,
                        feature_discount_statement: label || undefined,
                        feature_one_page_after_url: `${window.location.origin}${property.url}`,
                        ...(isNpl && {
                            feature_section_name: 'Aset Bank Lainnya',
                        }),
                        listing: property,
                        project_id:
                            property?.propertyPartner?.primaryProject?.originId,
                        developer_id:
                            property?.propertyPartner?.agent?.originId ||
                            property?.unregisterProject?.developerId,
                    },
                },
                [Trackers.Segment],
            );
        }, 0);
    };
    return { ref: { observe }, action: { onClickCard } };
};

export default useRecommendationSectionSegment;
